import axios from 'axios';

//axios封装
axios.defaults.timeout = 20000;
axios.defaults.baseUrl = '';
axios.defaults.withCredentials = true;

/**
 * http request 拦截器
 */
 axios.interceptors.request.use(
    (config) => {
        config.data = JSON.stringify(config.data);
        config.headers = {
        "Content-Type": "application/json",
        // "Content-Type": "application/x-www-form-urlencoded;",
        };
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
  
/**
 * http response 拦截器
 */
axios.interceptors.response.use(
    (response) => {
        //这里可以根据响应结果做点什么
        return response;
    },
    (error) => {
        if(error.response){
            // 根据请求失败的http状态码去给用户相应的提示
            // msag(error.response.status);
        }else{
            // alert('The request timed out, please refresh and try again!');
        }
    }
);

/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */
 export function getRequest(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: params }).then(
            (response) => {
                if(!!response){
                    resolve(response.data);
                }else{
                    resolve('apiErr');
                }
            }
        ).catch((error) => {
          reject(error);
        });
    });
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
  
 export function postRequest(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data).then(
        (response) => {
            if(!!response){
                resolve(response.data);
            }else{
                resolve('apiErr');
            }
        },
        (error) => {
            reject(error);
        }
        );
    });
}